// Column totals of the Budget Report DCA detail view (Accounts/GetDCABudgetDetailedSummary rows).
// effectiveConsumption = total debit - credit: equals the DCA's consumed budget (value - balance).
export const dcaDetailTotals = (rows = []) => {
    const totals = rows.reduce((acc, transaction) => {
        acc.credit += parseFloat(transaction.credit || 0);
        acc.cashDebit += parseFloat(transaction.cashDebit || 0);
        acc.indent += parseFloat(transaction.indent || 0);
        acc.po += parseFloat(transaction.po || 0);
        acc.invoiceDebit += parseFloat(transaction.invoiceDebit || 0);
        acc.internalDebit += parseFloat(transaction.internalDebit || 0);
        acc.bankDebit += parseFloat(transaction.bankDebit || 0);
        acc.totalDebit += parseFloat(transaction.totalDebit || 0);
        return acc;
    }, {
        credit: 0,
        cashDebit: 0,
        indent: 0,
        po: 0,
        invoiceDebit: 0,
        internalDebit: 0,
        bankDebit: 0,
        totalDebit: 0
    });
    totals.effectiveConsumption = totals.totalDebit - totals.credit;
    return totals;
};
